import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import scrollToComponent from 'react-scroll-to-component';

import TagManager from "../../TagManager";
import {t} from "../../Translations";
import StepSubTitle from "../widgets/StepSubTitle";
import Radio from "../widgets/Radio";
import Configuration from "../../Configuration";

/**
 * Step 2 first step component
 */
class Step2_1 extends React.Component {

    static propTypes = {
        className: PropTypes.string,

        // Triggered when step data change
        onDataChange: PropTypes.func,

        // Used to initialize step data
        data: PropTypes.shape({
            rank2: PropTypes.number,
            rank3: PropTypes.number,
            fullcar: PropTypes.number,
            luggage: PropTypes.number
        })
    };

    static defaultProps = {
        data: {
            rank2: undefined,
            rank3: undefined,
            fullcar: undefined,
            luggage: undefined
        }
    };

    componentDidMount() {
        const {data, vehicleDetail} = this.props

        TagManager.sendEvent(
            '/consommation/form/estimation-precise-usage/step-1',
            'form page',
            null,
            'consommation estimation precise',
            1,
            'votre besoin',
            data.bodyStyle,
            `${vehicleDetail.model} ${vehicleDetail.bodyStyle} ${vehicleDetail.commercialName} ${vehicleDetail.engine}`
        )
    }

    /**
     * Data labels
     *
     * @type {{rank2: string, rank3: string, fullcar: string, luggage: string}}
     */
    labels = {
        rank2: t('Step2_need_question_1'),
        rank3: t('Step2_need_question_2'),
        fullcar: t('Step2_need_question_3'),
        luggage: t('Step2_need_question_4')
    };

    /**
     * Available data for all choices in this step
     *
     * @type {*[]}
     */
    choices = [
        {label: t('Step2_need_answer_1'), value: 1},
        {label: t('Step2_need_answer_2'), value: 2},
        {label: t('Step2_need_answer_3'), value: 3}
    ];

    /**
     * References to DOM node of Radios components
     */
    radioRefs = [];

    onDataChange = (dataKey, index, radioRefs) => value => {
        // Scroll to next Radio

        const nextRefIndex = index < radioRefs.length - 1 ? (index + 1) : index
        radioRefs.forEach(function(element,index) {
          
        });
        scrollToComponent(radioRefs[nextRefIndex], {
            duration: 500
        })

        this.props.onDataChange && this.props.onDataChange(dataKey)(value);
    };

    componentDidUpdate(state){
  

        if(document.querySelectorAll('.raw-1 .cccu-button.selected').length >1){
      
            var DOMelemetsRadio = document.querySelectorAll(".raw-1 .cccu-button:not(.selected)");
            for(var i = 0;i< DOMelemetsRadio.length ; i++){
      
             DOMelemetsRadio[i].classList.add('unselect-button');
            
              DOMelemetsRadio[i].setAttribute("disabled","true");


            } 
        } else 
        if (document.querySelectorAll('.radio-container.raw-1 .cccu-button.selected').length===1){
              
             var DOMelemetsRadio2 = document.querySelectorAll(".radio-container.raw-1 .cccu-button:not(.selected)");
            for(var j = 0;j< DOMelemetsRadio2.length ; j++){
                DOMelemetsRadio2[j].classList.remove('unselect-button');
                DOMelemetsRadio2[j].removeAttribute("disabled");
                 }
            }
               
        
    }

    render() {
        const {className, data} = this.props;
        const client = ("undefined" !== typeof Configuration.brand && Configuration.brand === "P" ? "ap":"");
        const buttonClass = "button-step-2-"+client;
        const classes = classNames(
            "container-form-step2",
            "p-4",
            "radio-line",
            {
                [className]: className !== undefined
            }
        );

        return (
            <section className={classes}>
                <StepSubTitle>
                    {t('Step2_need_title')}
                </StepSubTitle>

                {Object.keys(this.labels).map((dataKey, index) =>
                

                    <Radio 
                        ref={radio => this.radioRefs[index] = radio}
                        key={index}
                        buttonStep2={buttonClass}
                        label={this.labels[dataKey]}
                        data={this.choices}  
                        value={data[dataKey]} 
                        onChange={this.onDataChange(dataKey, index, this.radioRefs)} 
                        onClick={this.handleClick}
                        order={index} 

                    />
                )}
            </section>
        )
    }
}

export default Step2_1;



// WEBPACK FOOTER //
// ./src/components/steps/Step2_1.js